module.exports = __webpack_public_path__ + "static/david-close-min-cd033dff3bb2b07256d73e21b71b13ba.jpg";